/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials(value) {
    if (!('Email' in value) || value['Email'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Email': json['Email'],
        'EmailCode': json['EmailCode'] == null ? undefined : json['EmailCode'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentialsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Email': value['Email'],
        'EmailCode': value['EmailCode'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateWithExternalIdEmailCredentials.js.map